"use strict";
import request from "@/utils/request";
const config = require("@/../config/config.json");
import logger from "@/utils/logger";

export async function svc_getShifts(data) {
	return request(`${config.apiUrl}reports/shift_times`, {
    method: "POST",
    data: data,
	});
}
